var _path, _polygon, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWannafind(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lag_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 1562 862",
    y: "0px",
    x: "0px",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    enableBackground: "new 0 0 1562 862",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m254.3 0h211.5l-116.5 373h264.5l41-373h211.5l41.5 373h555l99 186h-1416.5s-169 0.5-138.5-94c48-91.5 247.5-465 247.5-465z",
    fill: "#3C73E7"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "1051.8 1.5 1263.3 1.5 1401.8 265 1131.8 265",
    fill: "#3C73E7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#3C73E7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m218.2 651.6l-24.2 209.8h-67.8c-6.2-32.2-11.7-68.9-16.4-110-2.2 17.6-7.2 54.3-15.1 110h-67.4l-24.3-209.8h52.7l5.7 73.2 5.5 70.7c2-36.6 7-84.6 15-143.9h56.4c0.7 6.1 2.7 29.2 5.9 69.2l6 79.8c3.1-50.8 8.1-100.4 15.1-149h52.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m361.6 651.6l31 209.7h-55.5l-2.9-37.7h-19.4l-3.3 37.7h-56.1l27.7-209.7h78.5zm-28.8 134.9c-2.7-23.8-5.5-53.1-8.3-88.1-5.5 40.2-9 69.5-10.4 88.1h18.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m564.5 651.6v209.7h-47.6l-28.2-95.3v95.3h-45.4v-209.7h45.4l30.4 94.4v-94.4h45.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m748.9 651.6v209.7h-47.6l-28.2-95.3v95.3h-45.4v-209.7h45.4l30.4 94.4v-94.4h45.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m906 651.6l31 209.7h-55.5l-2.9-37.7h-19.4l-3.3 37.7h-56.1l27.7-209.7h78.5zm-28.8 134.9c-2.7-23.8-5.5-53.1-8.3-88.1-5.5 40.2-9 69.5-10.4 88.1h18.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m987.7 685.5s2.2-33.9 36.7-33.9 55.3 0 55.3 0v42h-37.7v39.8h33.5v39.9h-33.5v88.1h-54.3v-175.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1188.5 651.6v209.7h-54.3v-209.7h54.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1372.9 651.6v209.7h-47.6l-28.2-95.3v95.3h-45.4v-209.7h45.4l30.4 94.4v-94.4h45.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1436.1 651.6h40.6c26.2 0 43.9 1.2 53.2 3.6 9.2 2.4 16.3 6.4 21.1 11.9s7.8 11.7 9 18.5 1.8 20.1 1.8 40v73.5c0 18.8-0.9 31.4-2.6 37.8-1.8 6.3-4.8 11.3-9.2 14.9s-9.8 6.1-16.2 7.5-16.2 2.1-29.1 2.1h-68.5v-209.8zm54.3 35.9v138c7.8 0 12.6-1.6 14.4-4.7 1.8-3.2 2.7-11.7 2.7-25.7v-81.5c0-9.5-0.3-15.6-0.9-18.3s-2-4.6-4.1-5.9-6.1-1.9-12.1-1.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWannafind);
export default __webpack_public_path__ + "static/media/wannafind.8168bc6677f0ce1abbef3dbb1ed80a24.svg";
export { ForwardRef as ReactComponent };